import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DASHBOARD, FORGOT_PASSWORD, SOCIETY_CONTROLLER, SOCIETY_PORTAL, SOCIETY_PORTAL_LOGIN } from "../../../../Routing/routes";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ErrorMessage, Form, Formik } from "formik";
import { loginValidation } from "../../../../validationSchema/SocietyController/authSchema";
import CircularProgress from "@mui/material/CircularProgress";
import { login } from "../../../../redux/actions/AuthActions/AdminLoginaAction/AdminLoginAction";
import webTokenStorer from "../../../../utils/webStorer";
const Login = () => {
    // eslint-disable-next-line no-unused-vars
    const [_loginData, _setLoginData] = useState();
    const [showPass, setShowPass] = useState(false);
    const navigate = useNavigate();
    const loginDetails = useSelector(state => state.adminLoginReducer)
    const dispatch = useDispatch();
    const handleSaveClick = (values, { resetForm, initialValues }) => {
        // alert('fads');
        dispatch(login({ ...values, onSuccess: () => { navigate(SOCIETY_CONTROLLER + DASHBOARD) } }))
    }
    // useEffect(() => {
    //     if (webTokenStorer.getToken()) {
    //         navigate(SOCIETY_CONTROLLER + DASHBOARD)
    //     }
    // }, [])
    return (
        <>
            {!!(webTokenStorer.getToken2()) && <Navigate to={SOCIETY_CONTROLLER + DASHBOARD} />}
            {<section className='auth bg-base d-flex flex-wrap'>
                <div className='auth-left d-lg-block d-none'>
                    <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                        <img src="/assets/images/auth/auth-img.png" alt="" />
                    </div>
                </div>
                <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                    {loginDetails?.loading ? <div className="tw-text-center"><CircularProgress /> </div> :
                        <div className='max-w-464-px mx-auto w-100'>
                            <div>
                                <h4 className='mb-12'>Administrator Login</h4>
                                <p className='mb-32 text-secondary-light text-lg'>
                                    Welcome back! please enter your detail
                                </p>
                            </div>
                            <Formik
                                initialValues={{
                                    email: '',
                                    password: '',
                                }}
                                enableReinitializ={true}
                                validationSchema={loginValidation}
                                onSubmit={handleSaveClick}
                            >
                                {(formik) => {
                                    return (
                                        <Form >
                                            <div className="mb-16">
                                                <div className='icon-field '>
                                                    <span className='icon top-50 translate-middle-y'>
                                                        <Icon icon='mage:email' />
                                                    </span>
                                                    <input
                                                        type='email'
                                                        className='form-control h-56-px bg-neutral-50 radius-12'
                                                        placeholder='Email'
                                                        onChange={(e) => formik.setFieldValue('email', e.target.value)}
                                                        value={formik.values.email}
                                                        required
                                                    />

                                                </div>
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`email`} />
                                                </div>
                                            </div>
                                            <div className="mb-16">
                                                <div className='icon-field '>
                                                    <span className='icon top-50 translate-middle-y'>
                                                        <Icon icon='f7:lock' />
                                                    </span>
                                                    <input
                                                        type={showPass ? 'text' : 'password'}
                                                        min={1}
                                                        className='form-control h-56-px bg-neutral-50 radius-12'
                                                        placeholder='Passoword'
                                                        name="password"
                                                        onChange={(e) => { formik.setFieldValue('password', e.target.value) }}
                                                        value={formik.values.password}
                                                    />
                                                    {showPass ? <span onClick={() => { setShowPass(!showPass) }} class="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light" ></span> : <span onClick={() => { setShowPass(!showPass) }} class="toggle-password ri-eye-off-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"></span>}

                                                </div>
                                                <div
                                                    className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}
                                                >
                                                    <ErrorMessage name={`password`} />
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className='d-flex justify-content-between gap-2'>
                                                    {/* <div className='form-check style-check d-flex align-items-center'>
                                        <input
                                            className='form-check-input border border-neutral-300'
                                            type='checkbox'
                                            defaultValue=''
                                            id='remeber'
                                        />
                                        <label className='form-check-label' htmlFor='remeber'>
                                            Remember me{" "}
                                        </label>
                                    </div> */}
                                                    <Link to={SOCIETY_CONTROLLER + FORGOT_PASSWORD} className='text-primary-600 fw-medium'>
                                                        Forgot Password?
                                                    </Link>
                                                </div>
                                            </div>
                                            <button
                                                type='submit'
                                                className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                                            >
                                                {" "}
                                                Sign In
                                            </button>
                                            <Link
                                                to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN}
                                                className='btn btn-outline-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-16 d-flex align-items-center justify-content-center'
                                            >
                                                Go to Society Login
                                            </Link>
                                            {/* <div className='mt-32 center-border-horizontal text-center'>
                                                <span className='bg-base z-1 px-4'>Or sign in with</span>
                                            </div> */}
                                            {/* <div className='mt-32 d-flex align-items-center gap-3'>
                                <button
                                    type='button'
                                    className='fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50'
                                >
                                    <Icon
                                        icon='ic:baseline-facebook'
                                        className='text-primary-600 text-xl line-height-1'
                                    />
                                    Google
                                </button>
                                <button
                                    type='button'
                                    className='fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50'
                                >
                                    <Icon
                                        icon='logos:google-icon'
                                        className='text-primary-600 text-xl line-height-1'
                                    />
                                    Google
                                </button>
                            </div> */}
                                            {/* <div className='mt-32 text-center text-sm'>
                                                <p className='mb-0'>
                                                    Don’t have an account?{" "}
                                                    <Link to={SOCIETY_CONTROLLER + SIGN_UP} className='text-primary-600 fw-semibold'>
                                                        Sign Up
                                                    </Link>
                                                </p>
                                            </div> */}
                                        </Form>
                                    )
                                }}
                            </Formik>
                        </div>}
                </div>
            </section >}
        </>

    );
}

export default Login;
